import React, { useState, useEffect } from "react";
import api from "../../Services/api";
import MenuLateral from "../../Componentes/MenuLateral";
import { FaSearch } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { FaUserAlt, FaTruck } from 'react-icons/fa';
import ListaVisita from '../../Componentes/ListaVisita';
import { useNavigate } from "react-router-dom";
import "./styles.css";

const Motorista = () => {
  const [filtro, setfiltro] = useState('');
  const { IDmotorista } = useParams();
  const [DadosMotorista, setDadosMotorista] = useState([]);
  const [NomeMotorista, setNomeMotorista] = useState('-');
  const [VeiculoMotorista, setveiculoMotorista] = useState('-');
  const [dadosVisitas, setdadosVisitas] = useState([]);
  const [lote, setlote] = useState('');

  const [ordenacao, setOrdenacao] = useState('nome');

  const [totalVisitas, settotalVisitas] = useState(0);
  const [visitasEmAndamento, setvisitasEmAndamento] = useState(0);
  const [svisitasConcluidas, setvisitasConcluidas] = useState(0);
  
  const [somaQuantidadeTotal , setsomaQuantidadeTotal ] = useState(0);
  const [somaQuantidadeEntregue, setsomaQuantidadeEntregue ] = useState(0);

  const [somaValorTotal , setsomaValorTotal ] = useState(0);
  const [somaValorEntregue, setsomaValorEntregue ] = useState(0);

  const [progresso, setprogresso] = useState(0);

  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("usuarioLogado") === null) {
      navigate("/");
    }
    carregaDadosMotorista(IDmotorista);
  }, []);

  useEffect(() => {
    carregaListaVisitas(IDmotorista, filtro);

    const intervalo = setInterval(() => {
      carregaListaVisitas(IDmotorista, filtro);
    }, 60000);
    return () => clearInterval(intervalo);

  }, []);

  async function carregaDadosMotorista(id) {
    let retorno = await buscaMotorista(id);
    if (retorno) {
      setDadosMotorista(retorno.data);
      setNomeMotorista(
        String(retorno.data.Usuario.IDusuario).padStart(6, '0') +
        '  |  ' + retorno.data.Usuario.pessoa.nome +
        '  |  CPF: ' + formatCPF(retorno.data.Usuario.pessoa.cpf)
      );
      if (retorno.data.Usuario.lote) {
        setlote(retorno.data.Usuario.lote.IDlote);
      }
    }
  }

  async function carregaListaVisitas(IDmotorista, pFiltro) {
    let retorno = await buscaVisitas(IDmotorista, pFiltro);

    if (retorno && retorno.data && retorno.data.Lote) {
      setdadosVisitas(retorno.data.Lote.resultVisita);

      if (retorno.data.Lote.modeloVeiculo) {
        setveiculoMotorista(
          retorno.data.Lote.modeloVeiculo +
          ' | PLACA: ' + retorno.data.Lote.placaVeiculo
        );
      }

      const total = retorno.data.Lote.resultVisita.length;
      const andamento = retorno.data.Lote.resultVisita.filter(visita => visita.situacaovisita === 1).length;

      // Soma total de quantidade de produtos (independente da situação)
      const somaQuantidadeTotal = retorno.data.Lote.resultVisita.reduce((acc, visita) => {
        return acc + parseFloat(visita.quantidade || 0);
      }, 0);

      // Soma da quantidade de produtos entregues (situacaovisita === 1)
      const somaQuantidadeEntregue = retorno.data.Lote.resultVisita.reduce((acc, visita) => {
        if (visita.situacaovisita === 1) {
          return acc + parseFloat(visita.quantidade || 0);
        }
        return acc;
      }, 0);

      setsomaQuantidadeTotal(somaQuantidadeTotal);
      setsomaQuantidadeEntregue(somaQuantidadeEntregue);


      // Valor total e entregue
      const somaValorTotal = retorno.data.Lote.resultVisita.reduce((acc, visita) => {
        return acc + parseFloat(visita.valor || 0);
      }, 0);

      const somaValorEntregue = retorno.data.Lote.resultVisita.reduce((acc, visita) => {
        if (visita.situacaovisita === 1) {
          return acc + parseFloat(visita.valor || 0);
        }
        return acc;
      }, 0);

      setsomaValorTotal(somaValorTotal);
      setsomaValorEntregue(somaValorEntregue);


      settotalVisitas(total);
      setvisitasEmAndamento(andamento);
      setvisitasConcluidas(total - andamento);
      setprogresso((andamento / total) * 100);
    } else {
      console.error("Erro: Dados de visitas não encontrados.");
      setdadosVisitas([]);
      settotalVisitas(0);
      setvisitasEmAndamento(0);
      setvisitasConcluidas(0);
      setprogresso(0);
    }
  }


  async function buscaVisitas(IDmotorista, Pfiltro) {
    try {
      const response = await api.get('/visitaMov/' + IDmotorista + '?filter=' + Pfiltro);
      return response;

    } catch (error) {
      console.log(error);
      return error;
    }
  }

  function formatCPF(cpf) {
    cpf = cpf.replace(/\D/g, '');

    if (cpf.length !== 11) {
      return cpf;
    }
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  }

  async function buscaMotorista(id) {
    try {
      const response = await api.get('/usuario/' + id);
      return response;

    } catch (error) {
      console.log(error);
      return error;
    }
  }

  async function AbrirHistorico(IDusu) {
    navigate(`/Historico/${IDusu}`);
  }

  const visitasFiltradas = ordenacao === 'ocorrencia'
    ? dadosVisitas.filter(visita =>
      visita.movimentos && visita.movimentos.some(mov => mov.tipo === 5)
    )
    : dadosVisitas;

  return (
    <div className="menu-container-motorista">
      <MenuLateral />

      <div id="painel_principal_motorista" align="center">
        <h5 style={{ paddingBottom: '0%' }}>ENTREGAS | Carga nº {lote}</h5>

        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          width: '100%'
        }}>
          <div style={{ width: '20%', padding: '5px', textAlign: "center", paddingBottom: "0px" }}>
            <div style={{ width: "100%", height: "20px", background: "#ccc" }}>
              <div style={{
                width: `${progresso}%`,
                height: "100%",
                background: "#4caf50",
                transition: "width 0.5s ease-in-out"
              }} />
            </div>
            <p style={{ fontWeight: "bold", textAlign: "center", fontSize: "11px", color: "black" }}>
              (  {((visitasEmAndamento/totalVisitas) * 100).toFixed(2)} % ) - {visitasEmAndamento} de {totalVisitas} 
            </p>
          </div>
        </div>

        <div id="painel_motorista" align="left">
          <div className="row">
            <div className="col-sm-9">
              <div>
                <p style={{ fontSize: '0.7em', fontWeight: 'bold' }}> <FaUserAlt /> Motorista:</p>
                <p style={{ fontWeight: 'Normal', marginTop: '-15px', fontSize: '0.9em' }}>
                  {NomeMotorista}
                </p>
              </div>
              <div>
                <p style={{ fontSize: '0.7em', fontWeight: 'bold' }}> <FaTruck /> Veículo:</p>
                <p style={{ fontWeight: 'Normal', marginTop: '-15px', fontSize: '0.9em' }}>{VeiculoMotorista}</p>
              </div>
            </div>
            <div className="col-sm-2" style={{ paddingLeft: '3%' }}>
              <p style={{ fontSize: '0.7em', marginBottom: '5px' }}><b>LEGENDA :</b></p>
              <div style={{ minHeight: '12px', width: '100px', backgroundColor: '#666', fontSize: '0.6em', color: 'white', padding: '2px', paddingLeft: '7%' }}>
                <div>NÃO VISITADO</div>
              </div>
              <div style={{ minHeight: '12px', width: '100px', marginTop: '2px', backgroundColor: '#c3c366', fontSize: '0.6em', color: 'white', padding: '2px', paddingLeft: '7%' }}>
                <div>EM ANDAMENTO</div>
              </div>
              <div style={{ minHeight: '12px', width: '100px', marginTop: '2px', backgroundColor: '#0a5c0a', fontSize: '0.6em', color: 'white', padding: '2px', paddingLeft: '7%' }}>
                <div>VISITADO</div>
              </div>
              <div style={{ minHeight: '12px', width: '100px', marginTop: '2px', backgroundColor: '#931010', fontSize: '0.6em', color: 'white', padding: '2px', paddingLeft: '7%' }}>
                <div>NÃO ENTREGUE</div>
              </div>
            </div>
          </div>

          <div className="row" style={{ paddingLeft: '0%', color:'black', fontSize:'12px' }}>
            {/* 🔍 Filtro de Ordenação */}
            <div className="col-sm-4 form-group" style={{ width: '15%' }}>
              <label htmlFor="ordenacao" className="form-label" style={{ fontSize: '1.2em' }}>
                Listar:
              </label>
              <select
                className="form-control"
                id="ordenacao"
                value={ordenacao}
                onChange={(e) => setOrdenacao(e.target.value)}
              >
                <option value="nome">Todas</option>
                <option value="ocorrencia">Com Ocorrência</option>
              </select>

            </div>

            <div className="col-sm-2">
            </div>

            <div className="col-sm-2" style={{backgroundColor:'#949393ff'}}>
              VOLUME:
              <div className="progress" style={{ height: '10px', backgroundColor: '#aca7a7ff' }}>
                <div
                  className="progress-bar"
                  role="progressbar"
                  style={{ width: `${(somaQuantidadeEntregue / somaQuantidadeTotal) * 100}%` }}
                  aria-valuenow={(somaQuantidadeEntregue / somaQuantidadeTotal) * 100}
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
              <p style={{ fontWeight: "bold", textAlign: "center", fontSize: "11px", color: "black" }}>
                ( {((somaQuantidadeEntregue / somaQuantidadeTotal) * 100).toFixed(2)} % )
                <p style={{fontSize:'9px'}}>
                  {somaQuantidadeEntregue}&nbsp; de &nbsp;{somaQuantidadeTotal}
                </p>
              </p>
            </div>

            <div className="col-sm-2" style={{backgroundColor:'#949393ff', marginLeft:'5px'}}>
              VALOR:
              <div className="progress" style={{ height: '10px', backgroundColor: '#aca7a7ff' }}>
                <div
                  className="progress-bar"
                  role="progressbar"
                  style={{ width: `${(somaValorEntregue / somaValorTotal) * 100}%` }}
                  aria-valuenow={(somaValorEntregue / somaValorTotal) * 100}
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
    
              <p style={{ fontWeight: "bold", textAlign: "center", fontSize: "11px", color: "black" }}>
                ( {((somaValorEntregue / somaValorTotal) * 100).toFixed(2)} % )&nbsp;&nbsp;  
                <p style={{fontSize:'9px'}}>
                  {(somaValorEntregue).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })} 
                  &nbsp;&nbsp; de &nbsp;&nbsp; {(somaValorTotal).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
                </p>
              </p>

            </div>
            
            <div className="col-sm-2" style={{ display: 'flex', justifyContent: 'flex-end' }}>
              
              <button className="btn btn-light" style={{height:'40px', marginTop: '30px'}} onClick={
                () => AbrirHistorico(IDmotorista)
              } >Ver entregas antigas...</button>

            </div>

          </div>
          <br/>
        </div>

        <div id="div_painel_motorista">
          <ListaVisita listaVisitas={visitasFiltradas} idmotorista={IDmotorista} />
        </div>

      </div>
    </div>
  );
};

export default Motorista;
